(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["microdata-schema"] && !Shopify.designMode) return;
  try {
    (() => {
    const productScript = document.getElementById('ds-product-jsonld');
    if (!productScript) return;

    const mergeProductReviews = () => {
      const reviewsScript = document.getElementById('reviewsWidgetProductSnippets');
      if (!reviewsScript) return;

      try {
        const productSchema = JSON.parse(productScript.textContent);
        const reviewsSchema = JSON.parse(reviewsScript.textContent);
        const rating = reviewsSchema.aggregateRating;

        if (!['Product', 'ProductGroup'].includes(productSchema['@type'])) return;
        if (reviewsSchema['@type'] !== 'Product' || !rating) return;
        if (!(Number(rating.reviewCount || rating.ratingCount) > 0)) return;

        productSchema.aggregateRating = rating;
        if (Array.isArray(reviewsSchema.review)) {
          productSchema.review = reviewsSchema.review;
        }

        productScript.textContent = JSON.stringify(productSchema);
        reviewsScript.remove();
      } catch {
        return;
      }
    };

    mergeProductReviews();
    new MutationObserver(mergeProductReviews).observe(document.head, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
